import { HttpClient } from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown';
import { faCaretRight } from '@fortawesome/free-solid-svg-icons/faCaretRight';
import { faCaretUp } from '@fortawesome/free-solid-svg-icons/faCaretUp';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faExclamation } from '@fortawesome/free-solid-svg-icons/faExclamation';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons/faMinusCircle';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons/faPlusCircle';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons/faQuestionCircle';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle';
import { faBolt } from '@fortawesome/pro-light-svg-icons/faBolt';
import { faBrowser } from '@fortawesome/pro-light-svg-icons/faBrowser';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight';
import { faChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp';
import { faCircleNotch } from '@fortawesome/pro-light-svg-icons/faCircleNotch';
import { faCloudDownload } from '@fortawesome/pro-light-svg-icons/faCloudDownload';
import { faCommentAltDots } from '@fortawesome/pro-light-svg-icons/faCommentAltDots';
import { faFlask } from '@fortawesome/pro-light-svg-icons/faFlask';
import { faGift } from '@fortawesome/pro-light-svg-icons/faGift';
import { faHeart } from '@fortawesome/pro-light-svg-icons/faHeart';
import { faLaptop } from '@fortawesome/pro-light-svg-icons/faLaptop';
import { faShoePrints } from '@fortawesome/pro-light-svg-icons/faShoePrints';
import { faWifiSlash } from '@fortawesome/pro-light-svg-icons/faWifiSlash';
import { NgbConfig, NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { AppComponent } from '../app.component';
import { PageLayoutModule } from '../components/page-layout/page-layout.module';
import { PageSettingsComponent } from '../components/pages/page-settings/page-settings.component';
import { UiButtonModule } from '../components/ui/ui-button/ui-button.module';
import { UICustomRadioModule } from '../components/ui/ui-custom-radio/ui-custom-radio.module';
import { UiCustomSliderModule } from '../components/ui/ui-custom-slider/ui-custom-slider.module';
import { MissingTranslationDefaultHandler } from '../i18n/handler/missing-tranlsation-default-handler';
import { WebpackTranslateLoader } from '../i18n/loader/webpack-translate-loader.loader';
import { CommonService } from '../services/common/common.service';
import { DevService } from '../services/dev/dev.service';
import { DisplayService } from '../services/display/display.service';
import { CameraSectionService } from '../services/camera/camera-section/camera-section.service';
import { ChunkLoadErrorHandler } from '../services/error-handler/global.service';
import { InitializerService } from '../services/initializer/initializer.service';
import { MetricsTranslateService } from '../services/mertics-traslate/metrics-translate.service';
// import { ModalErrorMessageComponent } from '../components/modal/modal-error-message/modal-error-message.component';
import { MetricsModule } from '../services/metrics/metrics.module';
import { HomeComponent } from './../components/home/home.component';
import { AppRoutingModule } from './app-routing.module';
import { CommonPipeModule } from './common/common-pipe.module';
import { CommonUiModule } from './common/common-ui.module';
import { NavbarModule } from './common/navbar.module';
import { HardwareDashboardModule } from './hardware-settings/hardware-dashboard.module';
import { ModernPreloadModule } from './modern-preload/modern-preload.module';
import { CommsService } from '../services/comms/comms.service';
import {
	MatRippleModule,
	MAT_RIPPLE_GLOBAL_OPTIONS,
	RippleGlobalOptions,
} from '@lenovo/material/core';
import { CdkScrollableModule } from '@angular/cdk/scrolling';
import { OverlayModule } from '@angular/cdk/overlay';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@lenovo/material/tooltip';
import { HardwareScanModule } from './hardware-scan/hardware-scan.module';
import { HardwareScanRoutingModule } from './hardware-scan/hardware-scan-routing.module';
import { ModernPreloadModuleMF } from './modern-preload-mf/modern-preload-mf.module';
const globalRippleConfig: RippleGlobalOptions = {
	disabled: true,
	animation: {
		enterDuration: 300,
		exitDuration: 0,
	},
};

@NgModule({
	declarations: [AppComponent, HomeComponent, PageSettingsComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useClass: WebpackTranslateLoader,
				deps: [HttpClient],
			},
			missingTranslationHandler: {
				provide: MissingTranslationHandler,
				useClass: MissingTranslationDefaultHandler,
			},
			isolate: false,
		}),
		NavbarModule,
		NgbModalModule,
		NgbTooltipModule,
		UiButtonModule,
		RouterModule,
		CommonPipeModule,
		CommonUiModule,
		FormsModule,
		ReactiveFormsModule,
		ModernPreloadModule,
		ModernPreloadModuleMF,
		PageLayoutModule,
		FontAwesomeModule,
		HardwareDashboardModule,
		HardwareScanModule,
		HardwareScanRoutingModule,
		UiCustomSliderModule,
		UICustomRadioModule,
		MetricsModule,
		MatRippleModule,
		CdkScrollableModule,
		OverlayModule,
	],
	exports: [
		NavbarModule,
		RouterModule,
		CommonPipeModule,
		CommonUiModule,
		ModernPreloadModule,
		ModernPreloadModuleMF,
		PageLayoutModule,
		UiCustomSliderModule,
	],
	providers: [
		CommonService,
		MetricsTranslateService,
		DevService,
		DisplayService,
		CameraSectionService,
		CookieService,
		CommsService,
		NgbConfig,
		{
			provide: ErrorHandler,
			useClass: ChunkLoadErrorHandler,
		},
		{
			provide: APP_INITIALIZER,
			useFactory: (initializerService: InitializerService) =>
				initializerService.initialize.bind(initializerService),
			deps: [InitializerService],
			multi: true,
		},
		{ provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
		{ provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: { position: 'above' } },
	],
	entryComponents: [
		// ModalErrorMessageComponent
	],
	bootstrap: [AppComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {
	constructor(library: FaIconLibrary) {
		library.addIcons(faCheck);
		library.addIcons(faExclamation);
		library.addIcons(faBolt);
		library.addIcons(faChevronRight);
		library.addIcons(faTimesCircle);
		library.addIcons(faCaretUp);
		library.addIcons(faCaretRight);
		library.addIcons(faCaretDown);
		library.addIcons(faPlusCircle);
		library.addIcons(faMinusCircle);
		library.addIcons(faChevronUp);
		library.addIcons(faChevronDown);
		library.addIcons(faCircleNotch);
		library.addIcons(faBrowser);
		library.addIcons(faGift);
		library.addIcons(faCommentAltDots);
		library.addIcons(faShoePrints);
		library.addIcons(faWifiSlash);
		library.addIcons(faFlask);
		library.addIcons(faExclamationTriangle);
		library.addIcons(faExclamationCircle);
		library.addIcons(faQuestionCircle);
		library.addIcons(faCloudDownload);
		library.addIcons(faLaptop);
		library.addIcons(faHeart);
	}
}
